/**
 * The final station. Pressing F by the chair starts the computer's PIN challenge.
 */

import type { Vec3 } from '../utils/math';
import { boxCenter, boxContainsXZ, type FinishSpec } from './Level';
import type { InteractContext, Interactable } from './Interactable';

export class FinishSeat implements Interactable {
  readonly id = 'oma-paikka';
  readonly prompt = 'ISTU PAIKALLESI';

  private seated = false;
  private readonly center: Vec3;

  constructor(
    private readonly spec: FinishSpec,
    private readonly onSit: (simulationTime: number) => void,
  ) {
    this.center = boxCenter(spec.zone);
  }

  get isSeated(): boolean {
    return this.seated;
  }

  focusPoint(): Vec3 {
    return this.center;
  }

  /** In the zone is enough - no aim requirement to sit down. */
  canInteract(context: InteractContext): boolean {
    if (this.seated) return false;
    return boxContainsXZ(this.spec.zone, context.feet.x, context.feet.y, context.feet.z);
  }

  interact(context: InteractContext): void {
    if (this.seated) return;
    this.seated = true;
    this.onSit(context.simulationTime);
  }

  reset(): void {
    this.seated = false;
  }
}
